<template>
   <v-content>
    <v-container fluid>
        <div>
          <div class="text-center">
            <h3
              class="display-1 bold text-uppercase"
              style="user-select: none padding-bottom: 3%; text-align: center;"
              >Ketti Valley! <br> கேத்தி வேலே!
            </h3>
          </div>
          <p class="text-justify display-1">{{heading}}</p>
          <p class="text-justify subheading">{{headingtamil}}</p>
          </div>
          <v-divider></v-divider>
    </v-container>
       <v-card
        class="mx-auto"
        max-width="344"
      >
        <v-img
          src="https://3.bp.blogspot.com/-XlERL8lQ5Ow/VMSTojYQfhI/AAAAAAAAAQ4/h1t13ZlgOPQ/s1600/dress.jpg"
          height="200px"
        ></v-img>

        <v-card-title class="headline">
          People Of Ketti Valley
          கேத்தி வேலே மக்கள் விவரம்
        </v-card-title>

        <v-card-actions>
          <v-btn
            color="primary"
            text
          >
            Culture
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            icon
            @click="show = !show"
          >
            <v-icon>{{ show ? 'fas fa-arrow-alt-circle-up' : 'fas fa-arrow-alt-circle-down' }}</v-icon>
          </v-btn>
        </v-card-actions>

        <v-expand-transition>
          <div v-show="show">
            <v-divider></v-divider>
            <v-card-text>
              {{population}} <br>
              {{populationtamil}}
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
  </v-content>
</template>

<script>
export default {
  data: () => ({
    show: false,
    items: [
      {
        src: 'https://lh5.googleusercontent.com/p/AF1QipPH0ASjN9N1KayMqWxPblCA6NnPqX4d1bUoFF4=w408-h306-k-no',
      },
      {
        src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXF8um0EBa4jOGXGMp-UTXKGD_spiC8UIIwJqQFXH7QFOQ6P15Gw',
      },
      {
        src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ9rXECIC7Vfm80CG7VeSV6jRP-nGZmKGDghgRXG0u4mXd1sH3Y',
      },
      {
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/NMR_train_at_Ketti_05-02-26_75.jpeg/300px-NMR_train_at_Ketti_05-02-26_75.jpeg',
      },
      {
        src: 'https://badaga.files.wordpress.com/2007/01/fromthe-halla.jpg',
      },
    ],
    heading: 'Ketti is a small town nestled in a large valley of the same name.It is located in The Nilgiris District of Tamil Nadu State, South India and is a Revenue Village of Coonoor Taluk. Upper Ketti is another village called Yellanahalli, which is located on the main Coonoor to Ooty road.',
    headingtamil: 'கேத்தி  என்ற ஊர், அதே பெயரில் பெரிய பள்ளத்தாக்கில் அமைந்துள்ளது. இது தென்னிந்தியாவின் தமிழ்நாடு மாநிலத்தில் நீலகிரி மாவட்டத்தில் அமைந்துள்ளது. குன்னூர் வட்டத்தில் வருவாய் கிராமம் ஆகும்.மேல் கேத்தி  என்பது, முக்கிய குன்னூர் - ஊட்டி சாலையில் உள்ள, எல்லநள்ளி  என்ற மற்றொரு கிராமம்.',
    population: 'Most of the population are manual labourers. Agriculture, rearing livestock, masonry constitute the majority of the work done by the individuals in this place. In addition to this, they also take up jobs in the surrounding industrial establishments, such as the Needle Industries, the mushroom factory, Ambica tea factory, Mini flower garden near Palada bus stop and the various educational institutions (these include the CSI College of Engineering, the Laidlaw Memorial School and the CSI Middle School)',
    populationtamil: 'மக்கள் தொகையில் பெரும்பாலானோர் உடலுழைப்பு த் தொழிலாளர்களாவர். விவசாயம், கால்நடை வளர்ப்பு, பண்ணைக் கூரை என இங்கு தனி நபர்கள் செய்யும் வேலைகளில் பெரும்பாலானவை.இது தவிர, ஊசி தொழிற்சாலை, காளான் தொழிற்சாலை, அம்பிகா தேயிலை தொழிற்சாலை, பாலாட பஸ் ஸ்டாப் அருகே மினி மலர் தோட்டம், பல்வேறு கல்வி நிறுவனங்கள் (இவற்றில் சி.எஸ்.ஐ பொறியியல் கல்லூரி, லேடிலா மெமோரியல் பள்ளி, சி.எஸ்.ஐ. நடுநிலைப்பள்ளி ஆகியவை அடங்கும்) போன்ற தொழில் நிறுவனங்களிலும் வேலை வாய்ப்பு கிடைக்கும்.',
  }),
};
</script>

<style>
.heading-left {
  padding : 0%;
}
.heading-right {
  padding : 0%;
}
</style>
